import { FC } from 'react';
import { CatTextLink } from '@blocks-react/components/TextLink';
import { ClearFilterProps } from '../types';
import styles from '../NotificationDrawer.module.scss';

export const ClearFilter: FC<ClearFilterProps> = ({
  title,
  handleClearFilter,
  tabIndex
}) => {
  return (
    <CatTextLink
      size="xs"
      className={`${styles['notification_drawer-clear-filter']}`}
      onClick={handleClearFilter}
      onKeyDown={handleClearFilter}
      data-testid="clear-filter-button"
      tabIndex={tabIndex}
    >
      {title}
    </CatTextLink>
  );
};
